import React, { Component } from "react";
import App from "../../App";
import {Button, Col, Form, Row} from "react-bootstrap";
import {Link, withRouter} from "react-router-dom";
import {toast} from "react-toastify";
import {getData, getDetails, update} from "../../services/baseServices";
import { updatePartner } from "../../services/partnerServices";
import PartnerForm from "./Form";
import { FaLongArrowAltLeft } from "react-icons/all";
import { convertToSlug } from "../../helper/utils";

class Edit extends Component {
  state = {
    partnerInfo: {},
    formData: {},
    partner: { details: {}, address_attributes: {} },
    isFormValidated: false,
    isLoadingData: true,
    isSubmitting: false,
    readyToSubmit: true,
    metaInfo: {},
    uniqueSlug: ''
  };

  componentDidUpdate(prevProps, prevState) {
    const {
      formData
    } = this.state
    if (prevState.formData?.slug !== formData?.slug) {
        if(formData?.slug) {
            getData('slugs/uniqueness', {slug: formData.slug, id: this.props.match.params.id, type: "Category"})
            .then(res => this.setState({uniqueSlug: res.success}))
            .catch(err => this.setState({uniqueSlug: ''}))
        } else {
            this.setState({uniqueSlug: ''})
        }
    }
  }

  setDistributorId = (ds_id) => {
    const formData = {...this.state.formData};
    formData['distributor_id'] = ds_id;
    this.setState({ formData });
  }

  componentDidMount() {
    getDetails("partners", this.props.match.params.id)
      .then((res) => {
        this.setState({ partnerInfo: res.data });
        const formData = { ...this.state.formData };
        formData["route_id"] = res.data.route?.id;
        formData["area_id"] = res.data.addresses?.area_id;
        formData["thana_id"] = res.data.addresses?.thana_id;
        formData["distributor_id"] = res.data.route?.distributor_id;
        formData["address_line"] = res.data.addresses?.address_line;
        formData["status"] = res.data.status;
        formData["schedule"] = res.data.schedule;
        formData["is_commission_applicable"] =
          res.data.is_commission_applicable;
        formData["image"] = res.data.image;
        formData["work_days"] = res.data.work_days
        formData["slug"] = res.data.slug;
        formData["business_type"] = res.data.business_type;
        this.setState({ formData }, () => {});
        const metaData ={
          metaTitle:res?.data.meta_info.meta_title,
          metaTitleBn:res?.data.meta_info.bn_meta_title,
          metaDescription:res?.data.meta_info.meta_description,
          metaDescriptionBn:res?.data.meta_info.bn_meta_description,
          metaKeywords:res?.data.meta_info.meta_keyword,
          metaKeyKeywordsBn:res?.data.meta_info.bn_meta_keyword,
        }
        this.setState({metaInfo:metaData})
      })
      .catch((errMsg) => {});
  }

  handleServiceHourOnChange = (name, obj) => {
    const formData = { ...this.state.formData };
    formData[name] = obj;
    this.setState({ formData }, () => {
      const invalidServiceHrExist = (element) => element.validTime === false;
      this.setState({
        readyToSubmit: !formData.work_days.some(invalidServiceHrExist),
      });
    });
  };

  handleInputOnChange = (e) => {
    const formData = {...this.state.formData};
    if(e.target.name === 'slug') {
      const slug = convertToSlug(e.target.value)
      formData['slug'] = slug;
    }else{
      formData[e.target.name] = e.target.value;
    }

    this.setState({formData}, () => {
    })
  };

  handleOnMetaInputChange = (e) => {
    const metainfo = { ...this.state.metaInfo };
    const name = e.target.name;
    const value = e.target.value;
    const updatedMetaInfo = { ...metainfo, [name]: value };
    this.setState({ metaInfo: updatedMetaInfo });
  };
  handleOnChangeKeywordValue = (en_bn, value) => {
    const mitainfoDetails = { ...this.state.metaInfo };
    const valueIdArr = [];
    if (value?.length > 0) {
      value.forEach((val) => {
        valueIdArr.push(val.value);
      });
    }
    if (en_bn === "en") {
      mitainfoDetails.metaKeywords = valueIdArr;
    } else {
      mitainfoDetails.metaKeyKeywordsBn = valueIdArr;
    }
    this.setState({ metaInfo: mitainfoDetails });
  };

  handleUpdatePartner = (e) => {
    e.preventDefault();
    const formInfo = { ...this.state.formData };
    const metaData = { ...this.state.metaInfo };
    const meta_datum_attributes = {
      meta_title: metaData.metaTitle,
      bn_meta_title: metaData.metaTitleBn,
      meta_description: metaData.metaDescription,
      bn_meta_description: metaData.metaDescriptionBn,
      meta_keyword: metaData.metaKeywords,
      bn_meta_keyword: metaData.metaKeyKeywordsBn,
    };
    const updatedFormInfo = { ...formInfo, meta_datum_attributes };
    this.setState({ formData: updatedFormInfo });

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      form.className += " was-validated";
      this.setState({ isFormValidated: true });
    } else {
      this.setState({ isSubmitting: true }, () => {
        let partner = { ...this.state.formData };
        const phone = partner["phone"]?.length === 14 ? partner["phone"]?.substring(3) : partner["phone"];
        partner = {...partner, phone};

        const formattedWorkDays = partner?.work_days?.map((obj, i) => ({
          ...obj,
          day_index: i,
          opening_time: !obj.is_opened ? null : obj.opening_time,
          closing_time: !obj.is_opened ? null : obj.closing_time,
        }));
        partner.work_days = formattedWorkDays;
        const address_attributes = {
          address_line: partner.address_line,
          area_id: parseInt(partner.area_id),
          thana_id: parseInt(partner.thana_id),
          district_id: parseInt(partner.district_id),
        };

        delete partner.address_line;
        delete partner.area_id;
        delete partner.thana_id;
        delete partner.district_id;
        if (typeof partner.image_file === "undefined") delete partner.image;
        const formData = { partner, address_attributes };

        if (
          formData.partner.password === formData.partner.password_confirmation
        ) {
          console.log('edit partner meta info', formData);

          updatePartner("partners", this.props.match.params.id, formData)
            .then((res) => {
              if (res.success) {
                this.props.history.push(`/partner/list`);
                toast.success("updated");
              } else {
                toast.error(res.message);
              }
            })
            .catch((errMsg) => {
              toast.error(errMsg);
              this.setState({ isSubmitting: false });
            })
            .finally(() => {
              this.setState({ isSubmitting: false });
            });
        } else {
          toast.error("Password doesn't match with confirmed password");
          this.setState({ isSubmitting: false });
        }
      });
    }
  };
  render() {
    return (
      <App layout="boxed">
        <div className="page-header">
          <h2 className="page-title">Edit Partner</h2>
          <div className="ml-auto">
            <Link
              to={`${process.env.PUBLIC_URL}/partner/list`}
              className="btn btn-sm btn-link"
            >
              <FaLongArrowAltLeft /> Back to Partner List
            </Link>
          </div>
        </div>

        <div className="card-block">
          <div className="block-body">
            <>
              <PartnerForm
                setDistributorId={this.setDistributorId}
                handleClick={this.handleUpdatePartner}
                handleServiceHourOnChange={this.handleServiceHourOnChange}
                handleInputOnChange={this.handleInputOnChange}
                partnerInfo={this.state.partnerInfo}
                metaInfo={this.state.metaInfo}
                handleOnMetaInputChange={this.handleOnMetaInputChange}
                handleOnChangeKeywordValue={this.handleOnChangeKeywordValue}
                formData={this.state.formData}
                isSubmitting={this.state.isSubmitting}
                readyToSubmit={this.state.readyToSubmit}
                uniqueSlug={this.state.uniqueSlug}
              />
            </>
          </div>
        </div>
      </App>
    );
  }
}
export default withRouter(Edit);
